import { z } from "zod";
export const BILLING_FEATURES = [
    "followups", "escalation", "outcomes", "crmUpdates", "knowledge", "analytics",
];
export const billingFeaturesSchema = z.object({
    followups: z.boolean(), escalation: z.boolean(), outcomes: z.boolean(),
    crmUpdates: z.boolean(), knowledge: z.boolean(), analytics: z.boolean(),
}).strict();
export const billingQuotaWindowSchema = z.enum(["ROLLING_30_DAYS", "TRIAL_TOTAL"]);
//# sourceMappingURL=billing-access.js.map